import { getLayoutProps } from '@/utils/layout/layout';
import React from 'react';
import PageLayout from '@/components/PageLayout';
import Head from 'next/head';
import CookiesPage from '@/components/CookiesPage/CookiesPage';
import styles from '@/styles/Cookies.module.css';
import { getCookiesPage } from '@/api/cms';
import { CustomMetaHead } from '@/components/CustomMetaHead/CustomMetaHead';

export default function Cookies({ cookies, responsiveLogo, metadata }) {
  return (
    <>
      <Head>
        <title>{process.env.displayName}</title>
        <meta name="description" content={`App for ${process.env.displayName} by Wave Grocery`} />
        <meta name="viewport" content="width=device-width, initial-scale=1" />
        <link rel="icon" href={responsiveLogo} />
      </Head>
      <CustomMetaHead metadata={metadata} />

      <main className={styles.mainContainer}>
        <div className={styles.cookiesContainer}>
          <CookiesPage fields={cookies} />
        </div>
      </main>
    </>
  );
}

Cookies.getLayout = function getLayout(page) {
  return <PageLayout>{page}</PageLayout>;
};

export async function getStaticProps(context) {
  const layoutProps = await getLayoutProps({ headerProps: { selectedIndex: -1 } }, context.locale);

  const { data: cookiesData } = await getCookiesPage(context.locale);
  const cookies = cookiesData[0]?.content;
  const metadata = cookies.metadata;

  const messages = {
    common: (await import(`../../../prebuild-data/i18n/${context.locale}/common.json`)).default,
    cookies: (await import(`../../../prebuild-data/i18n/${context.locale}/cookies.json`)).default,
  };

  return {
    props: {
      ...layoutProps,
      cookies,
      messages,
      ...(metadata ? { metadata } : null),
    },
  };
}
